<input #addressText type="text" (focusout)="focusOut()" [value]="control?.value || initialAddress" 
       [ngClass]="control ? {
        'ng-pristine': !!control.pristine,
        'ng-touched': !!control.touched,
        'ng-untouched': !control.touched,
        'ng-valid': !!control.valid,
        'ng-invalid': !control.valid,
        'ng-dirty': !!control.dirty
    } : {}">